import { render, staticRenderFns } from "./CustomerAddresses.vue?vue&type=template&id=4de88d18&lang=pug&"
import script from "./CustomerAddresses.vue?vue&type=script&lang=js&"
export * from "./CustomerAddresses.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAddresses.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports